const { schemas, Model } = require('./src/index');

// here we use CommonJS style export to dynamically export all values in Model
// eslint-disable-next-line
module.exports = { schemas, ...Model };
